import SAApi from './_saApi';
import httpClient from '@/apis/base/httpclient';

class SASaleInvoiceStatusAPI extends SAApi {
  constructor() {
    super();
  }
  controllerName = 'SASaleInvoiceStatuss';

  /**
   * cập nhật trạng thái gửi hóa đơn
   * @returns
   * TTLONG 21/09/2022
   */
  async updateSendEmailStatus(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/UpdateSendEmailStatus`,
      data: payload,
    };

    return await httpClient.putAsync(request);
  }
  /**
   * Cập nhật trạng thái hủy hóa đơn
   * @returns
   * TTLONG 22/09/2022
   */
  async updateIsDeleted(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/UpdateIsDeleted`,
      data: payload,
    };

    return await httpClient.putAsync(request);
  }
  /**
   * cập nhật trạng thái gửi hóa đơn
   * @returns
   * TTLONG 21/09/2022
   */
  async getColumnData(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/GetColumnData`,
      data: payload,
    };

    return await httpClient.postAsync(request);
  }
}

export default new SASaleInvoiceStatusAPI();
